require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./information-security-and-quality-assurance-quality-assurance-and-testing-with-chai-test-if-an-object-is-an-instance-of-a-constructor.json") })
        }
      }, "path---information-security-and-quality-assurance-quality-assurance-and-testing-with-chai-test-if-an-object-is-an-instance-of-a-constructor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---information-security-and-quality-assurance-quality-assurance-and-testing-with-chai-test-if-an-object-is-an-instance-of-a-constructor!./.cache/json/information-security-and-quality-assurance-quality-assurance-and-testing-with-chai-test-if-an-object-is-an-instance-of-a-constructor.json
// module id = 2195
// module chunks = 231608221292675